
    /**
    * 设置主账号
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  export class IReqid17025 {}
  /**
 * YResult :YResult
 */
export class IResid17025 {
  code?: {};
  msg?: {};
  success?: {};
  exceptionMsg?: {};
}
  export default (account: any,  data?: IReqid17025): AxiosPromise<IResid17025> => request({
        method: 'POST',
        url: '/admin/account/set_main_account/'+account,
        data: data
      })